import React, { useContext } from 'react';
import { ARN } from '@aws-sdk/util-arn-parser';
import { OperatorInfo } from 'src/components/OperatorInfo';
import { StatusLabel } from 'src/components/StatusLabel';
import { Link } from 'react-router-dom';
import { ScalingTargetInfo } from 'src/components/ScalingTargetInfo';
import { OperatorModalContext } from 'src/context/operatorModalContext';
import {
  OperatorAction,
  OperatorActionMenu,
} from 'src/components/OperatorActionsMenu';

export interface AutoScalingConfigNodeProps {
  header: string;
  info: {
    id: string;
    operatorName: string;
    operatorFlowId: string;
    modelName?: string;
    modelArn?: ARN;
  };
  status: OperatorJobStatus;
  arnList: ARN[];
  arnStrings: string[];
}

export const AutoScalingConfigNode = ({
  header,
  info,
  status,
  arnList,
  arnStrings,
}: AutoScalingConfigNodeProps) => {
  const { setRetryConfig, setOverrideConfig } =
    useContext(OperatorModalContext);

  const operatorActions: OperatorAction[] = [];

  if (status === 'FAILED') {
    operatorActions.push({
      name: 'Retry',
      description: 'retry operators',
      requiredPermission: 'READ_AND_LIMITED_ACTION',
      actionFn: () => {
        setRetryConfig({
          action: 'retry',
          id: info.operatorFlowId,
          operatorName: info.operatorName,
        });
      },
    });
  }

  if (status === 'FAILED' || status === 'PENDING') {
    operatorActions.push({
      name: 'Override',
      description: 'override operators',
      requiredPermission: 'ADMINISTER',
      actionFn: () => {
        setOverrideConfig({
          id: info.operatorFlowId,
          action: 'SKIPPEDOVERRIDE',
          operatorName: info.operatorName,
          operatorStatus: status,
        });
      },
    });
  }

  return (
    <div className="job-visualization-node pointer-events-auto">
      <div className="job-visualization-node__header">
        <h3>{header}</h3>
        <div className="job-visualization-node__status-container">
          <StatusLabel loading={false} label={status} />
        </div>
      </div>
      <OperatorInfo operatorId={info.id} operatorName={info.operatorName} />
      <ScalingTargetInfo arn={arnList[0] || ''} arnStrings={arnStrings} />

      <div className="job-visualization-node__buttons">
        <div className="job-visualization-node__button-group">
          <Link
            to={`../logs?operatorName=${info.operatorName}`}
            relative="path"
            target="_blank"
          >
            View Logs
          </Link>

          <OperatorActionMenu actions={operatorActions} />
        </div>
      </div>
    </div>
  );
};
